/**
 * @generated SignedSource<<bb66e37c5eba484b81a1a98f50039ce6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedHeadScriptTags_metadata$data = {
  readonly microdata: string | null;
  readonly " $fragmentType": "SharedHeadScriptTags_metadata";
};
export type SharedHeadScriptTags_metadata$key = {
  readonly " $data"?: SharedHeadScriptTags_metadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedHeadScriptTags_metadata">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedHeadScriptTags_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "microdata",
      "storageKey": null
    }
  ],
  "type": "MetaData",
  "abstractKey": null
};

(node as any).hash = "b1b4576dd4c2a4a6bbd5990cb11c9cf0";

export default node;
